function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".filter_svg__st0{fill:none;stroke:currentColor;stroke-width:.25;stroke-linejoin:round;stroke-miterlimit:10}");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "filter_svg__st0",
  d: "M.147 3.791H1.65m1.586 0h8.317"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "filter_svg__st0",
  cx: 2.443,
  cy: 3.791,
  r: 0.793
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "filter_svg__st0",
  d: "M.147 7.915h8.27m1.586 0h1.55"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  className: "filter_svg__st0",
  cx: 9.21,
  cy: 7.909,
  r: 0.793
});

function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "filter_svg__Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 11.7 11.7",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default SvgFilter;